module.exports = __webpack_public_path__ + "static/media/discover.8d8ce30d.svg";